import React from 'react';

import {
  ChevronLeftIcon,
  ChevronRightIcon,
  CmButton,
  CmFlex,
  CmIconButton,
  CmText,
} from '@/components/uiParts';
import { buildPageNumbers } from '@/pages/externals/mos-pos-resend/service';

type Props = {
  currentPage: number;
  itemsPerPage: number;
  totalItems: number;
  onPageChange: (page: number) => void;
};

/**
 * ページ番号付きのページネーション。
 * NOTE 既存の CmHeadingPagination / TablePagination はいずれも先頭・前・次・末尾の
 *      4ボタンのみでページ番号を持たないため、本画面用に新規作成した。
 *      他画面でも必要になった場合は uiParts へ切り出す余地がある。
 */
export const PageNumberPagination: React.VFC<Props> = ({
  currentPage,
  itemsPerPage,
  totalItems,
  onPageChange,
}) => {
  if (totalItems === 0) return <></>;

  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === totalPages;
  const start = (currentPage - 1) * itemsPerPage + 1;
  const end = Math.min(currentPage * itemsPerPage, totalItems);
  const pageSlots = buildPageNumbers(currentPage, totalPages);

  return (
    <CmFlex justifyContent="space-between" alignItems="center" width="100%">
      <CmText>{`全 ${totalItems} 件中 ${start} - ${end} 件を表示`}</CmText>

      <CmFlex alignItems="center" gridGap="4px">
        {/*
         // @ts-ignore TS2590 */}
        <CmIconButton
          aria-label="前のページ"
          icon={<ChevronLeftIcon boxSize={5} />}
          size="sm"
          isDisabled={isFirstPage}
          onClick={() => onPageChange(currentPage - 1)}
        />
        {pageSlots.map((slot, index) =>
          slot === 'ellipsis' ? (
            <CmText
              // 省略記号は同じ並びに 2 つ出るため index で区別する
              key={`ellipsis-${index}`}
              px="2"
              color="gray.500"
            >
              …
            </CmText>
          ) : (
            // @ts-ignore TS2590
            <CmButton
              key={slot}
              size="sm"
              px="3"
              variant={slot === currentPage ? 'solid' : 'outline'}
              onClick={() => onPageChange(slot)}
            >
              {slot}
            </CmButton>
          )
        )}
        <CmIconButton
          aria-label="次のページ"
          icon={<ChevronRightIcon boxSize={5} />}
          size="sm"
          isDisabled={isLastPage}
          onClick={() => onPageChange(currentPage + 1)}
        />
      </CmFlex>
    </CmFlex>
  );
};
